export default __webpack_public_path__ + "static/media/train-station.0478a4a5.jpg";